<template>
  <c-box>
    <c-box
      d="inline-block"
      w="100%"
      cursor="pointer"
      py="xs"
      :px="{ base: 0, sm: 'sm' }"
      :_hover="{ background: 'rgba(0, 0, 0, 0.05)' }"
      @click="open(result)"
      tabindex="0"
      @keydown.enter="open(result)"
    >
      <c-box
        v-if="result.imageAddress || result.imageAddress === null"
        d="inline-block"
        w="55px"
        h="39px"
        verticalAlign="middle"
        :backgroundImage="result.imageAddress ? `url('${result.imageAddress}')` : undefined"
        backgroundSize="contain"
        backgroundRepeat="no-repeat"
        backgroundPosition="center"
        mx="0.375rem"
      ></c-box>
      <c-icon
        v-if="result.iconName"
        :name="result.iconName"
        d="inline-block"
        verticalAlign="middle"
        color="brand.beige"
        fill="white"
        size="1rem"
        mx="0.375rem"
      />
      <c-box d="inline-block" verticalAlign="middle" :w="widthFor(result, 'title')" mx="0.375rem">
        <c-text as="span" fontSize="sm" fontWeight="400">{{ result.title }}</c-text>
      </c-box>
      <c-box
        v-if="result.subTitle"
        d="inline-block"
        verticalAlign="middle"
        :w="widthFor(result, 'subTitle')"
        mx="0.375rem"
      >
        <c-text as="span" fontSize="sm" fontWeight="400">{{ result.subTitle }}</c-text>
      </c-box>
      <c-box
        v-if="result.tag"
        d="inline-block"
        float="right"
        verticalAlign="middle"
        :minWidth="widthFor(result, 'tag')"
        mx="0.375rem"
        textAlign="right"
      >
        <c-text
          as="span"
          fontSize="2xs"
          lineHeight="1"
          textTransform="uppercase"
          background="rgba(0, 0, 0, 0.05)"
          py="2xs"
          px="md"
          borderRadius="base"
          >{{ result.tag }}</c-text
        >
      </c-box>
    </c-box>
    <!-- TODO add support for attachments (after vacations)
    <c-box d="inline-block" v-for="attachment in result.attachments || []">
      <a :href="attachment.url" target="_blank"
        ><c-icon :name="attachment.iconName" color="brand.grayDark" size="1rem" />{{
          attachment.title
        }}</a
      >
    </c-box>
    -->
  </c-box>
</template>

<script lang="ts">
import { CBox, CHeading, CIcon, CText } from "@chakra-ui/vue";
import { ISearchResult } from "@iloq/shared";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "GlobalSearchResult",
  components: {
    CBox,
    CHeading,
    CIcon,
    CText,
  },
  props: {
    result: {
      type: Object as PropType<ISearchResult>,
      required: true,
    },
  },
  methods: {
    open(result: ISearchResult) {
      if (result.externalUrl) {
        window.open(result.externalUrl, "_blank");
      } else if (result.path) {
        this.$router.push({ path: result.path });
        this.$store.commit("globalSearch/setOverlayVisibility", false);
      } else if (result.clickHandler) {
        result.clickHandler();
      } else {
        console.warn("No way to open ", result.title);
      }
    },
    widthFor(result: ISearchResult, field: string): string {
      const fieldWeights: { [key: string]: number } = {
        title: 6,
        subTitle: 2,
        tag: 3,
      };
      const weightSum =
        (result.title ? fieldWeights.title : 0) +
        (result.subTitle ? fieldWeights.subTitle : 0) +
        (result.tag ? fieldWeights.tag : 0);
      const proportion = fieldWeights[field]! / weightSum;
      const marginCount =
        (result.imageAddress || result.imageAddress === null ? 1 : 0) +
        (result.iconName ? 1 : 0) +
        (result.title ? 1 : 0) +
        (result.subTitle ? 1 : 0) +
        (result.tag ? 1 : 0);
      return `calc(
        ${proportion} * (
          100%
          ${result.imageAddress || result.imageAddress === null ? "- 55px" : ""}
          ${result.iconName ? "- 1rem" : ""}
          - 0.75rem * ${marginCount}
        )
      )`;
    },
  },
});
</script>
